import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dropdown, Icons, TextField } from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import { isValidUrl } from "utils/urlUtils";
import { updateLocalBrand } from "assets/js/scenes/brand/actions";
import { validateEmail } from "utils/validators";

export const BrandLink = (props) => {
	const [link, setLink] = useState(props.link);
	const [valid, setValid] = useState("");
	const [message, setMessage] = useState(
		!props.link && props.useDefaultOption ? props.defaultMessage : null
	);
	const [showCustom, setShowCustom] = useState(
		props.link != null && props.link !== ""
	);

	useEffect(() => {}, []);

	function onDDChange(e, input, option) {
		let newLink = "";
		if (option.value === "custom") {
			setShowCustom(true);
			newLink = props.link;
			setMessage(null);
		} else if (option.value === "default") {
			setShowCustom(false);
			newLink = "";
			setMessage(props.defaultMessage);
		} else {
			setMessage(null);
			setShowCustom(false);
			newLink = "";
		}

		setLink(newLink);
		if (!props.path) {
			console.warn("Brand Link has no path");
		} else {
			props.updateLocalBrand(
				props.path,
				newLink,
				{ value: newLink, valid: "valid" },
				newLink === props.link
			);
		}
	}

	function openLink() {
		window.open(link, "_blank");
	}

	function validateUrl(url, inputName) {
		let message = <Translate value={"app-general-input-good"} />;
		let valid = "valid";

		if (url) {
			url = url.trim();

			if (url.match(/http[s]{0,1}:\/\//) === null) {
				url = "https://" + url;
			}

			if (!isValidUrl(url)) {
				message = <Translate value={"app-general-input-invalid-url"} />;
				valid = "error";
			}
		} else {
			valid = "";
			message = null;
		}

		return { value: url, valid: valid, message: message };
	}

	function handleLinkChange(e) {
		const { value } = e.currentTarget;
		setLink(value);
	}

	function handleLinkChangeTimeout(name, curValue) {
		const { valid, message, value } =
			props.type === "link" ? validateUrl(curValue) : validateEmail(curValue);

		setLink(value);
		setValid(valid);
		setMessage(message);
		if (!props.path) {
			console.warn("Brand color has no path");
		} else {
			props.updateLocalBrand(
				props.path,
				value,
				{ value: value, valid: valid },
				value === props.defaultLink
			);
		}
	}

	let options = [];

	if (props.useDefaultOption) {
		options.push({
			label: <Translate value={"app-brand-links-DD-default-" + props.type} />,
			value: "default",
			selected: link === "default",
		});
	} else {
		options.push({
			label: <Translate value="app-brand-links-DD-none" />,
			value: "none",
			selected: !link,
		});
	}

	options.push({
		label: <Translate value={"app-brand-links-DD-custom-" + props.type} />,
		value: "custom",
		selected: link && link !== "default",
	});

	return (
		<div className="brandElement-link">
			<Dropdown
				type="custom"
				shapeSytle="outline"
				onChange={onDDChange}
				options={options}
				message={showCustom ? "" : message}
			/>

			{showCustom && (
				<div className="customLink">
					<TextField
						onChange={handleLinkChange}
						valid={valid}
						message={message}
						timeoutOptions={{ callback: handleLinkChangeTimeout }}
						value={link}
					/>
					{props.type === "link" && (
						<Icons name="glyph-share" onClick={openLink} />
					)}
				</div>
			)}
		</div>
	);
};

BrandLink.propTypes = {
	link: PropTypes.string,
	defaultLink: PropTypes.string,
	updateLocalBrand: PropTypes.func,
	path: PropTypes.string,
	useDefaultOption: PropTypes.bool,
	type: PropTypes.oneOf(["link", "email"]),
	defaultMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

BrandLink.defaultProps = {
	link: null,
	useDefault: false,
	type: "link",
};

export default withRouter(
	connect(
		(state) => {
			return {};
		},
		(dispatch) =>
			bindActionCreators(
				{
					updateLocalBrand,
				},
				dispatch
			)
	)(BrandLink)
);
